import { Theme } from '@mui/material'

export const contactPageCAT4561VariantStyles = (theme: Theme) => ({
  flexBasisGrid: {
    flexBasis: 'auto'
  },
  buttonFullHeight: {
    height: '100%',
    '& button': {
      height: '100%'
    }
  }
})
